// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__iof4v","signatureButtonsRight":"ModalSign_signatureButtonsRight__YTngE"};